export enum OriginPlaceEnum {
    ND,
    Bolzano,
    Trento,
    Innsbruck
}
